import React from 'react';
import { Box, Flex, Heading, Button, Link, HStack } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

const Header = () => {
  return (
    <Box as="header" bg="blue.600" color="white" py={4}>
      <Flex 
        maxW="1200px" 
        mx="auto" 
        px={4} 
        justifyContent="space-between" 
        alignItems="center"
      >
        <Link as={RouterLink} to="/" _hover={{ textDecoration: 'none' }}>
          <Heading as="h1" size="lg">NIH Termination Tracker</Heading>
        </Link>
        
        <HStack spacing={4}>
          <Link as={RouterLink} to="/" color="white" fontWeight="medium">
            Share Your Experience
          </Link>
          <Link as={RouterLink} to="/about" color="white" fontWeight="medium">
            About
          </Link>
          <Button 
            as={RouterLink} 
            to="/stats" 
            colorScheme="whiteAlpha" 
            size="sm"
          >
            View Statistics
          </Button>
        </HStack>
      </Flex>
    </Box>
  );
};

export default Header;